document.addEventListener('alpine:init', () => {
	Alpine.data('sc_tabs', (cfg = {}) => ({
		activeTab: cfg.activeTab || 0,
		tabCount: cfg.tabCount || 0,

		select(i) {
			this.activeTab = i;
		},

		next() {
			if (!this.tabCount) return;
			this.activeTab = (this.activeTab + 1) % this.tabCount;
		},

		prev() {
			if (!this.tabCount) return;
			this.activeTab = (this.activeTab - 1 + this.tabCount) % this.tabCount;
		},

		isActive(i) {
			return this.activeTab === i;
		},
	}));
});
